<template>
    <div v-title="$route.meta.title">
      <div class="page-heading">
        <el-breadcrumb separator-class="el-icon-arrow-right">
          <el-breadcrumb-item to="/">首页</el-breadcrumb-item>
          <el-breadcrumb-item :to="this.tablePath">付款管理列表</el-breadcrumb-item>
          <el-breadcrumb-item>{{$route.meta.title}}</el-breadcrumb-item>
        </el-breadcrumb>
      </div>

      <template v-if="showErrorMsg">
        <error-panel v-if="detailErrorMsg" :message="detailErrorMsg" show-back/>
      </template>
      <template v-else>
      <layout-panel>
        <span slot="header">基本信息</span>
        <template slot="tools">
          <el-button v-if="!isReview"
                    size="mini"
                    type="primary"
                    @click="downloadPDF"
                    :loading="onDownloadDetail">生成PDF
          </el-button>
        </template>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
          <div class="re-el-form__flex">
            <div class="medium">
              <el-form-item label="付款ID：">
                <span> {{id}} </span>
              </el-form-item>
              <el-form-item label="申请人："
                            prop="applicant_name">
                <span>{{form.applicant_name}} / {{form.applicant_real_name}}</span>
              </el-form-item>
              <el-form-item label="部门："
                            prop="department_name">
                <span>{{form.department_name}}</span>
              </el-form-item>
              <el-form-item label="付款类型："
                            prop="type">
                <span>{{type[form.type] || '批量付款'}}</span>
              </el-form-item>
              <!-- 仅对公付款/预付费用显示最后付款日 -->
              <el-form-item v-if="showScheduleDate" label="最后付款日：">
                <span>{{ form.schedule_date }}</span>
              </el-form-item>
              <el-form-item label="是否加急："
                            prop="is_urgent">
                <span>{{form.is_urgent ? '是' : '否'}}</span>
              </el-form-item>
              <el-form-item v-if="form.is_urgent === 1" label="期望日期："
                            prop="expected_date">
                <span>{{ form.expected_date | formatExpectedDate }}</span>
              </el-form-item>
              <el-form-item label="付款公司："
                            prop="payment_company">
                <span>{{paymentCompanys[form.payment_company]}}</span>
              </el-form-item>
              <el-form-item label="付款账户："
                            prop="payment_company" v-if="form.payment_company_account">
                <span>{{form.payment_company_account.name + '/' + form.payment_company_account.number}}</span>
              </el-form-item>
              <el-form-item label="付款说明："
                            prop="desc">
                <span>{{ form.desc }}</span>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </layout-panel>

      <layout-panel v-if="!isBatch">
        <span slot="header">付款信息</span>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
          <div class="re-el-form__flex">
            <div class="medium">
              <el-form-item v-if="form.type" label="付款主体"
                            prop="paid_to_type">
                <span>{{form.paid_to_type === 1 ? '对私' : '对公'}}</span>
              </el-form-item>
            <el-form-item v-if="form.payment_channel_type" label="付款渠道类型："
                          prop="payment_channel_type">
              <span>{{ paymentChannelTypes[form.payment_channel_type] }}</span>
            </el-form-item>
            <el-form-item v-if="form.payment_account_type" label="付款账户类型："
                          prop="payment_account_type">
              <span>{{ paymentAccountTypes[form.payment_account_type] }}</span>
            </el-form-item>
              <el-form-item label="收款对象名称："
                            prop="company_name">
                <span>{{form.company_name}}</span>
              </el-form-item>
              <el-form-item label="银行账号："
                            prop="bank_account">
                <span>{{form.bank_account}}</span>
              </el-form-item>
              <el-form-item label="开户银行支行："
                            prop="bank">
                <span>{{form.bank}}</span>
              </el-form-item>
              <el-form-item label="开户银行总行："
                            prop="bank_headquarters">
                <span>{{form.bank_headquarters}}</span>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </layout-panel>

      <layout-panel>
        <span slot="header">费用信息</span>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
          <el-table
            class="payment-detail-table"
            :data="form.payment_detail"
            border
            stripe
            size="mini"
            style="width: 100%">
            <el-table-column type="index" label="序号" width="60" align="center" key="index"></el-table-column>

            <el-table-column label="项目编号" min-width="150" align="center" key="project_id">
              <template slot-scope="{ row }">
                <span style="word-break: break-all;">
                  {{row.project_id > 0 ? (projectNames[row.project_id] + '/' + row.project_number) : '无'}}
                </span>
              </template>
            </el-table-column>

            <el-table-column prop="department_name" label="费用承担部门" min-width="140" align="center" key="department_name"></el-table-column>

            <el-table-column label="一级科目" min-width="120" align="center" key="first_subject_name">
              <template slot-scope="{ row, $index }">
                <el-select
                  v-if="[5, 6, 7].includes(form.status * 1) && isReview"
                  v-model="row.first_subject"
                  @change="val => firstSubjectChange(val, $index)">
                  <el-option v-for="(label, value) in firstSubjects"
                             :key="value"
                             :label="label"
                             :value="Number(value)">
                  </el-option>
                </el-select>
                <span v-else>{{firstSubjects[row.first_subject]}}</span>
              </template>
            </el-table-column>

            <el-table-column label="二级科目" min-width="120" align="center" key="second_subject_name">
              <template slot-scope="{ row, $index }">
                <el-select
                  v-if="[5, 6, 7].includes(form.status * 1) && isReview"
                  v-model="row.second_subject">
                  <el-option v-for="(label, value) in secondSubjects[$index]"
                             :key="value"
                             :label="label"
                             :value="Number(value)">
                  </el-option>
                </el-select>
                <span v-else>{{secondSubjects[$index][row.second_subject]}}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="showFeesInfoFileds" label="发票类型" min-width="110" align="center" key="invoice_type">
              <template slot-scope="{ row, $index }">
                <el-select
                  v-if="[5, 6, 7].includes(form.status * 1) && isReview"
                  v-model="row.invoice_type"
                  @change="val => invoiceTypeChange(val, $index)">
                  <el-option v-for="(label, value) in invoiceType"
                             :key="value"
                             :label="label"
                             :value="Number(value)">
                  </el-option>
                </el-select>
                <span v-else>{{invoiceType[row.invoice_type]}}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="showFeesInfoFileds" label="税率%" min-width="120" align="center" key="taxRateType">
              <template slot-scope="{ row }">
                <el-input
                  v-if="[5, 6, 7].includes(form.status * 1) && isReview"
                  :disabled="row.invoice_type === 1"
                  placeholder="请输入"
                  v-model="row.tax_rate"></el-input>
                <span v-else>{{ row.invoice_type === 1 ? '-' : (taxRateType[row.tax_rate] || (row.tax_rate + '%')) }}</span>
                <!-- <el-select
                  v-model="row.tax_rate"
                  :disabled="row.invoice_type === 1"
                  filterable
                  allow-create
                  default-first-option
                  placeholder="请选择">
                  <el-option v-for="(label, value) in row.invoice_type === 3 ? {0: '0%', ...taxRateType} : taxRateType"
                            :key="value"
                            :label="label"
                            :value="Number(value)">
                  </el-option>
                </el-select> -->
              </template>
            </el-table-column>

            <el-table-column label="应付金额" min-width="110" align="center" key="amount">
              <template slot-scope="{ row }">
                <span>￥{{row.amount | seperateThousandsToFixed(2)}}</span>
              </template>
            </el-table-column>

            <el-table-column v-if="showFeesInfoFileds" prop="invoice_count" label="发票张数" min-width="90" align="center" key="invoice_count"></el-table-column>

            <el-table-column label="摘要" min-width="160" align="center" key="desc">
              <template slot-scope="{ row }">
                <span style="word-break: break-all;">{{row.desc}}</span>
              </template>
            </el-table-column>

            <el-table-column label="财务摘要" min-width="140" align="center" key="finance_desc">
              <template slot-scope="{ row }">
                <span v-if="financeDescReadonly">{{row.finance_desc}}</span>
                <el-input v-else v-model="row.finance_desc" placeholder="请输入"></el-input>
              </template>
            </el-table-column>

            <el-table-column v-if="showEditPaidAmount" label="实付金额" min-width="140" align="center" key="paid_amount_edit">
              <template slot-scope="{ row }">
                <span v-if="isRefund">{{row.paid_amount}}</span>
                <el-input-number
                  v-else
                  style="width: 100%"
                  controls-position="right"
                  :step="0.01"
                  :precision="2"
                  :min="0"
                  :max="Number(row.confirm_amount)"
                  v-model.number="row.paid_amount"
                />
              </template>
            </el-table-column>

            <el-table-column v-if="showWriteOffReivewInfo || showWriteOffForm" label="实付金额" min-width="120" align="center" key="paid_amount_view">
              <template slot-scope="{ row }">
                <span>{{row.paid_amount}}</span>
              </template>
            </el-table-column>
          </el-table>

          <div style="height: 12px;"></div>
          <div class="attachments-summary-row">
            <el-form-item class="attachments-summary-row__attachments" label="附件" prop="attached_file">
              <div class="view-navbar">
                <ul class="clear-both">
                  <li v-for="(item, index) in form.attached_file" :key="index">
                    <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                      <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                      <i v-else
                          class="sj-icon-pdf"
                          style=" font-size:100px; margin-top: 50px"
                          @click="onGetPdfFile(item, index)"></i>
                    </el-tooltip>
                  </li>
                </ul>
              </div>
            </el-form-item>

            <div class="attachments-summary-row__summary">
              <div class="invoice-summary">
                <div class="invoice-summary__list">
                  <div class="invoice-summary__item">
                    <span class="invoice-summary__label">应付金额合计：</span>
                    <span class="invoice-summary__value">￥{{totalAmount | seperateThousandsToFixed(2)}}</span>
                  </div>
                  <div v-if="showEditPaidAmount" class="invoice-summary__item">
                    <span class="invoice-summary__label">实付金额合计：</span>
                    <span class="invoice-summary__value">￥{{totalPaidAmount | seperateThousandsToFixed(2)}}</span>
                  </div>
                  <div v-if="showEditPaidAmount" class="invoice-summary__item">
                    <span class="invoice-summary__label">发票合计：</span>
                    <span class="invoice-summary__value">{{totalInvoiceCount}}</span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form>
      </layout-panel>

      <layout-panel>
        <span slot="header">审批人</span>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
          <div class="re-el-form__flex">
            <div class="medium" style="width: 100%">
              <el-form-item label="部门领导审批："
                            prop="department_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.department_approver_name}/${form.department_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <!-- approve_level -->
                    <span v-if="![11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="form.approve_level > 0" label="一级审批："
                            prop="first_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.first_approver_name}/${form.first_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <!-- approve_level -->
                    <span v-if="![1,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="form.approve_level > 1" label="二级审批："
                            prop="second_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.second_approver_name}/${form.second_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <span v-if="![1,2,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="form.approve_level > 2" label="三级审批："
                            prop="third_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.third_approver_name}/${form.third_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <span v-if="![1,2,3,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="form.approve_level > 3" label="四级审批："
                            prop="fourth_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.fourth_approver_name}/${form.fourth_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <span v-if="![1,2,3,4,11,12,13].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item v-if="form.is_urgent && form.special_approver" label="特批审批："
                            prop="fourth_approver">
                <el-row :gutter="20">
                  <el-col :span="8">
                    <span>{{`${form.special_approver_name}/${form.special_approver_real_name || '-'}`}}</span>
                  </el-col>
                  <el-col :span="6">
                    <span v-if="![1,2,3,4,11,12,13,14].includes(form.status)" style="color: #67C23A">已审批通过</span>
                  </el-col>
                </el-row>
              </el-form-item>
              <el-form-item label="抄送人："
                            prop="cc">
                <el-row :gutter="20">
                  <el-col :span="20">
                    <span style="white-space:pre-wrap; word-wrap: break-word;">{{form.cc_name}}</span>
                  </el-col>
                </el-row>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </layout-panel>
      <layout-panel>
        <span slot="header">付款信息</span>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="140px">
          <div class="re-el-form__flex">
            <div class="medium" style="width: 100%">
              <el-form-item label="付款状态："
                            prop="status">
                <span>{{status[form.status]}}</span>
              </el-form-item>
              <el-form-item label="实付金额合计："
                            prop="paid_amount_total">
                <span>{{form.paid_amount_total}}</span>
              </el-form-item>
              <el-form-item label="日志："
                            prop="log">
                <span style="white-space:pre-wrap;">{{form.log}}</span>
              </el-form-item>
              <el-form-item label="付款结果附件："
                            v-if="[8, 9, 10].includes(form.status * 1)"
                            prop="paid_attached_file">
                <div class="view-navbar">
                  <ul class="clear-both">
                    <li v-for="(item, index) in form.paid_attached_file" :key="index">
                      <el-tooltip class="item" effect="dark" :content="item.name" placement="bottom">
                        <img v-if="item.type === 'pic' && item.pic_url" style="width: 100px; height: 100px" :src="item.pic_url | ossHost" @click="onViewImage">
                        <i v-else
                           class="sj-icon-pdf"
                           style=" font-size:100px; margin-top: 50px"
                           @click="onGetPdfFile(item, index)"></i>
                      </el-tooltip>
                    </li>
                  </ul>
                </div>
              </el-form-item>

              <el-form-item v-if="showPurposeInput" label="汇款用途：">
                <span>{{ form.purpose || '-' }}</span>
              </el-form-item>
              <el-form-item label="驳回原因：">
                <el-input placeholder="驳回时请填写，通过无需填写" v-model="reason" :disabled="!allowReview"></el-input>
              </el-form-item>
              <el-form-item>
                <el-button type="primary" @click="onReview(true)" :disabled="!allowReview">通过</el-button>
                <el-button type="danger" @click="onReview(false)" :disabled="!allowReview">驳回</el-button>
              </el-form-item>
              <template v-if="([7, 8, 10, 16].includes(form.status)) && isReview">
              <el-form-item label="付款账户"
                              prop="payment_company_account_id">
                  <remote-select
                    style="width: 220px !important"
                    clearable
                  :disabled="shouldShowPaymentAccount"
                    id-key="id"
                    keyword-key="name"
                    label-key="name"
                    value-key="id"
                    placeholder="请选择付款账户"
                    v-model="payment_company_account_id"
                    :query-params="{ our_company_id: form.payment_company, is_disabled: 0 }"
                    :query-request="getCompanyAccountManagementTable"
                    :find-request="getCompanyAccountManagementDetail">
                  </remote-select>
                </el-form-item>
                <el-form-item label="付款日期:" prop="paid_date">
                  <el-date-picker
                    v-model="paid_date"
                    value-format="yyyy-MM-dd HH:mm:ss"
                    :picker-options="dateTimePickerRangeOptions"
                    type="date"
                    placeholder="选择日期">
                  </el-date-picker>
                </el-form-item>
                <el-form-item label="附件"
                        prop="paid_attached_file">
                  <el-upload
                    class="upload-demo"
                    action=""
                    :auto-upload="false"
                    :on-change="(file, fileList) => {onChangeFile(file, fileList, this.form.paid_attached_file)}"
                    :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.form.paid_attached_file)}"
                    multiple
                    :limit="20"
                    :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
                    :file-list="fileList"
                    ref="upload"
                    accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"
                    >
                    <el-tooltip class="item" effect="dark" content="点击上传附件" placement="right">
                    <el-button size="small"
                                type="primary">点击上传
                    </el-button>
                    </el-tooltip>
                    <div slot="tip"
                          class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
                    </div>
                  </el-upload>
                </el-form-item>
                <el-form-item>
                  <el-button type="primary" @click="onPayment(true)">付款完成</el-button>
                  <el-button @click="onCancel">取消</el-button>
                </el-form-item>
              </template>
            </div>
          </div>
        </el-form>
      </layout-panel>
      <!-- 冲销详情 -->
      <template v-if="[8,10].includes(form.status) && isPrepaymentType">
        <PaymentWriteOffInfo
          :form="form"
          :projectNames="projectNames"/>
      </template>
      <!-- 冲销审批 -->
      <PaymentWriteOffReview
       v-if="showWriteOffReivewInfo"
       :data="form"
       :projectNames="projectNames"
       :originSecondSubjects="originSecondSubjects"
       :writeOffAssociatedRelationships="writeOffAssociatedRelationships"
       :originFirstSubjects="originFirstSubjects"/>

      <layout-panel v-if="isRefund">
        <span slot="header">退款信息</span>
        <el-form size="medium"
                 label-width="120px">
          <div class="re-el-form__flex">
            <div class="medium">
              <el-form-item label="可退款金额："><span> ￥{{ (form.paid_amount_total - form.refund_amount_total) | seperateThousandsToFixed(2) }} </span></el-form-item>
              <el-form-item label="已退款金额："><span> ￥{{ form.refund_amount_total | seperateThousandsToFixed(2) }} </span></el-form-item>
              <el-form-item label="退款记录：">
                <span v-for="log in form.refund_detail" :key="log.id" style="display: block">
                  {{ `${log.created_at} ${log.creator_name} 退款 ￥${log.refund_amount_total} ` }}
                  <router-link :to="`/payment-refund/finance/detail/${log.id}`">
                    <span>{{`退款条目ID：${log.id}`}}</span>
                  </router-link>
                </span>
              </el-form-item>
            </div>
          </div>
        </el-form>
      </layout-panel>
      <layout-panel v-if="isRefund">
        <span slot="header">新增退款</span>
        <el-form ref="form"
                 :model="form"
                 size="medium"
                 label-width="80px">
          <el-row :gutter="20" style="margin-left: 0px">
            <el-col :span="1" class="col-center">序号</el-col>
            <el-col :span="2" class="col-center">项目编号</el-col>
            <el-col :span="3" class="col-center">费用承担部门</el-col>
            <el-col :span="2" class="col-center">一级科目</el-col>
            <el-col :span="2" class="col-center">二级科目</el-col>
            <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票类型</el-col>
            <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">税率%</el-col>
            <el-col :span="2" class="col-center">应付金额</el-col>
            <el-col v-if="showFeesInfoFileds" :span="2" class="col-center">发票张数</el-col>
            <el-col :span="2" class="col-center">摘要</el-col>
            <el-col :span="2" class="col-center">财务摘要</el-col>
            <el-col v-if="showEditPaidAmount" :span="2" class="col-center">退款金额</el-col>
          </el-row>
          <br/>

          <el-row :gutter="20" v-for="(detailItem, itemIndex) in form.payment_detail"
                  :key="itemIndex"
                  class="invoice-row"
                  style="margin-top:5px">
            <!--序号-->
            <el-col style="text-align: center" :span="1">
              {{itemIndex+1}}
            </el-col>
            <!-- 项目编号 -->
            <el-col key="project_id" :span="2">
              <span style="word-break: break-all;">{{detailItem.project_id > 0 ? (projectNames[detailItem.project_id] + '/' + detailItem.project_number) : '无'}}</span>
            </el-col>
            <!-- 费用承担部门 -->
            <el-col key="department_name" :span="3">
              <span>{{detailItem.department_name}}</span>
            </el-col>

            <!--一级科目-->
            <el-col :span="2">
              <span>{{firstSubjects[detailItem.first_subject]}}</span>
            </el-col>
            <!--二级科目-->
            <el-col :span="2">
              <span>{{secondSubjects[itemIndex][detailItem.second_subject]}}</span>
            </el-col>
            <!--发票类型-->
            <el-col v-if="showFeesInfoFileds" :span="2">
              <span>{{invoiceType[detailItem.invoice_type]}}</span>
            </el-col>
            <!--税率-->
            <el-col v-if="showFeesInfoFileds" :span="2" style="text-align:center;overflow: auto;">
              <span>{{ detailItem.invoice_type === 1 ? '-' : (taxRateType[detailItem.tax_rate] || (detailItem.tax_rate + '%')) }}</span>
            </el-col>
            <!--含税金额-->
            <el-col :span="2" style="text-align:center;overflow: auto;">
              <span>￥{{detailItem.amount | seperateThousandsToFixed(2)}}</span>
            </el-col>
            <!--发票张数-->
            <el-col v-if="showFeesInfoFileds" :span="2">
              <span>{{detailItem.invoice_count}}</span>
            </el-col>
            <!--摘要-->
            <el-col :span="2">
              <span style="word-break: break-all;">{{detailItem.desc}}</span>
            </el-col>
            <!-- 财务摘要 -->
            <el-col :span="2">
              <span style="word-break: break-all;">{{detailItem.finance_desc}}</span>
            </el-col>
            <el-col v-if="showEditPaidAmount" :span="2">
              <el-input v-model="refundForm.refund_detail[itemIndex].refund_amount"></el-input>
            </el-col>
          </el-row>
          <br/>
          <el-row class="invoice-row" :gutter="20">
            <el-col :span="spanWithType">
              <p style="padding: 0; margin:0; text-align: right;">应付金额合计：</p>
            </el-col>
            <el-col :span="2">
              ￥{{totalAmount | seperateThousandsToFixed(2)}}
            </el-col>
            <el-col v-if="showEditPaidAmount" :span="2">
              {{totalInvoiceCount}}
            </el-col>
            <el-col v-if="showEditPaidAmount" :span="2">
              <p style="padding: 0; margin:0; text-align: right;color: red;">退款金额合计：</p>
            </el-col>
            <el-col v-if="showEditPaidAmount" :span="2" style="color: red">
              ￥{{totalRefundAmount | seperateThousandsToFixed(2)}}
            </el-col>
          </el-row>

          <el-form-item label="附件"
                        prop="attached_file">
            <el-upload
              class="upload-demo"
              action=""
              :auto-upload="false"
              :on-change="(file, fileList) => {onChangeFile(file, fileList, this.refundForm.attached_file, 'finCenterUploadPaymentRefundFile')}"
              :before-remove="(file, fileList) => {beforeRemove(file, fileList, this.refundForm.attached_file)}"
              multiple
              :limit="20"
              :on-exceed="(file, fileList) => {handleExceed(file, fileList, 20)}"
              :file-list="fileList"
              ref="refundUpload"
              accept=".jpg, .jpeg, .png, .pdf, .eml, .html, .htm, .xls, .xlsx, .doc, .docx, .zip"
              >
              <el-tooltip class="item" effect="dark" content="点击上传附件" placement="right">
              <el-button size="small"
                          type="primary">点击上传
              </el-button>
              </el-tooltip>
              <div slot="tip"
                    class="el-upload__tip">请上传PNG/JPG/PDF/EML/HTML/WORD/EXCEL/ZIP文件，仅支持上传20个文件，20以上建议上传zip格式
              </div>
            </el-upload>
          </el-form-item>
          <el-form-item label="退款日期:" prop="refund_date">
            <el-date-picker
              v-model="refundForm.refund_date"
              value-format="yyyy-MM-dd HH:mm:ss"
              :picker-options="dateTimePickerRangeOptions"
              type="date"
              placeholder="选择日期">
            </el-date-picker>
          </el-form-item>
          <el-form-item label="备注:" prop="refund_date">
            <el-input style="width: 220px" v-model="refundForm.refund_desc" placeholder="请输入备注"></el-input>
          </el-form-item>
          <el-form-item>
            <el-button type="primary" @click="onRefund">提交</el-button>
            <el-button @click="onCancel">取消</el-button>
          </el-form-item>
        </el-form>
      </layout-panel>

      <attached-file :visible="attach_file_visible"
                     :file_title="file_title"
                     :url="attach_file_url"
                     @closeDialog="closeDialog"></attached-file>
      </template>
    </div>
  </template>

  <script>
  import 'viewerjs/dist/viewer.css'
  import Viewer from 'viewerjs'
  import { formRules, writeOffFormRules } from '@views/payment-manager-new/payment-manager.rules.js'
  import downloadJS from '@/vendor/download'
  import { getToken } from '@utils/auth'
  import moment from 'moment'
  import AttachedFile from '@/views/payment-manager-new/components/AttachedFile'
  import PaymentWriteOffInfo from '@/views/payment-manager-new/components/PaymentWriteOffInfo'
  import PaymentWriteOffReview from '@views/payment-approval-new/components/PaymentWriteOffReview'
  import ErrorPanel from '@/components/ErrorPanel'

  export default {
    components: {
      AttachedFile,
      PaymentWriteOffReview,
      PaymentWriteOffInfo,
      ErrorPanel
    },
    filters: {
      formatExpectedDate (date) {
        if (moment(date).isValid()) {
          return moment(date).format('YYYY-MM-DD')
        }
        return ''
      }
    },
    data () {
      return {
        id: 0,
        formRules,
        writeOffFormRules,
        onDownloadDetail: false,
        showErrorMsg: true,
        detailErrorMsg: '',
        fileList: [],
        userDetail: {},
        form: {
          purpose: '',
          approve_level: null,
          applicant_name: '',
          applicant_real_name: '',
          department_id: null,
          department_name: null,
          bank_account_snapshot: {
            name: null,
            bank_account: null,
            bank: null,
            bank_headquarters: null,
            remark: null,
          },
          desc: null,
          type: null,
          status: null,
          is_urgent: 0,
          payment_company: null,
          payment_company_account: null,
          payment_company_id: null,
          paid_to_type: 0,
          payment_channel_type: 0,
          payment_account_type: 0,
          user_bank_account_id: '', // 对私付款，用户账户信息 id
          company_bank_account_id: '', // 对公付款，公司账户信息 id，为0时创建新的对公付款账户信息
          company_name: null,
          bank_account: null,
          bank: null,
          bank_headquarters: null,
          department_approver: null,
          department_approver_name: null,
          department_approver_real_name: null,
          first_approver: null,
          first_approver_name: null,
          first_approver_real_name: null,
          second_approver: null,
          second_approver_name: null,
          second_approver_real_name: null,
          third_approver: null,
          third_approver_name: null,
          third_approver_real_name: null,
          fourth_approver: null,
          fourth_approver_name: null,
          fourth_approver_real_name: null,
          special_approver: null,
          special_approver_name: null,
          special_approver_real_name: null,
          cc: null,
          cc_name: null,
          expected_date: '',
          schedule_date: '', // 最后付款日
          apply_amount: null,
          paid_amount_total: null,
          payment_detail: [{
            id: null,
            project_id: null,
            project_number: null,
            department_id: null,
            department_name: null,
            first_subject: null,
            second_subject: null,
            invoice_type: null,
            tax_rate: null,
            amount: null,
            invoice_count: null,
            desc: null,
            finance_desc: null,
            paid_amount: null,
          }],
          attached_file: [{}],
          log: null,
          write_off_lists: [],
          paid_attached_file: [],

          // 退款
          refund_amount_total: null,
          refund_detail: [],
          refund_log: null,

          // 冲销
          written_off_amount: null,
          write_off_status: null,
        },
        firstSubjects: {},
        secondSubjects: [{}],
        projectNames: {},
        first_approver: null,
        second_approver: null,
        third_approver: null,
        fourth_approver: null,
        reason: null,
        payment_company_account_id: null,
        paid_date: null,
        // 退款
        refundForm: {
          attached_file: [],
          refund_desc: null,
          refund_date: null,
          refund_detail: [{
            id: '',
            refund_amount: null,
          }],
        },
        dateTimePickerRangeOptions: {
          disabledDate: function (time) {
            return time.getTime() > Date.now()
          },
        },
        attach_file_visible: false,
        file_title: '',
        attach_file_url: '',

        originFirstSubjects: null,
        originSecondSubjects: null,
        associatedRelationships: null,
        writeOffAssociatedRelationships: null,
        paymentCompanys: {},
      }
    },
    computed: {
      ...Vuex.mapState({
        user: state => state.login.user,
        type: state => state.paymentManagerNew.type,
        status: state => state.paymentManagerNew.status,
        invoiceType: state => state.paymentManagerNew.invoiceType,
        taxRateType: state => state.paymentManagerNew.taxRateType,
        paymentChannelTypes: state => state.paymentManagerNew.paymentChannelTypes,
        paymentAccountTypes: state => state.paymentManagerNew.paymentAccountTypes,
      }),
      // 是否显示汇款用途输入框: 付款审批跳转过来且汇款用途不为空时显示
      showPurposeInput () {
        return this.$route.meta.isApproval && this.form.purpose !== ''
      },
      // 退款
      showEditPaidAmount () {
        return [7].includes(this.form.status) || this.isRefund
      },
      // 费用明细-财务摘要：退款/核销表单/支付中（status=16）时只读
      financeDescReadonly () {
        return this.isRefund || this.showWriteOffForm || (this.form.status * 1) === 16
      },
      totalAmount () {
        return this.form.payment_detail.reduce((total, item) => {
          return total + Number(item.amount)
        }, 0)
      },
      totalInvoiceCount () {
        return this.form.payment_detail.reduce((total, item) => {
          return total + Number(item.invoice_count)
        }, 0)
      },
      // 实付金额合计：优先汇总实付金额（paid_amount），没有实付金额，则显示确认金额
      totalPaidAmount () {
        return this.form.payment_detail.reduce((total, item) => {
          const val = item.paid_amount !== null && item.paid_amount !== undefined && item.paid_amount !== ''
            ? item.paid_amount
            : item.confirm_amount
          return total + (Number(val) || 0)
        }, 0)
      },
      totalRefundAmount () {
        return this.refundForm.refund_detail.reduce((total, item) => {
          return total + Number(item.refund_amount)
        }, 0)
      },
      spanWithType () {
        if (this.isBatch) {
          return 12
        } else {
          if (this.form.status === 7) {
            // return 11
            return 16
          }
          if (this.isPrepaymentType || this.showWriteOffForm) {
            return 10
          }
        }
        return 16
      },
      showFeesInfoFileds () {
        if (this.isBatch) {
          return false
        } else {
          return !this.isPrepaymentType
        }
      },
      isBatch () {
        return this.form.type === 4
      },
      isReview () {
        return this.$route.meta.isReview
      },
      isPrepaymentType () {
        return this.form.type === 3
      },
      tablePath () {
        return '/payment-center/table'
      },
      /**
       * 是否展示“核销表单/核销相关信息”的模式开关
       * - 仅在预付款单（type=3）且处于审批页（route.meta.isReview）时生效
       * - 单据状态为已付款/部分付款（status=8/10）且仍存在待核销金额（wait_write_off != 0）时为 true
       * - true 时页面会进入核销处理展示逻辑，并将部分字段（如费用明细里的财务摘要）切换为只读展示
       */
      showWriteOffForm () {
        return [8, 10].includes(this.form.status) &&
        this.isPrepaymentType &&
        this.isReview &&
        this.form.wait_write_off !== 0
      },
      isRefund () {
        return this.$route.meta.isRefund
      },
      showWriteOffReivewInfo () {
        return !!this.form.write_off_lists.find(item => [6, 7].includes(item.status)) && this.form.type === 3 && [8, 10].includes(this.form.status) && [1, 2].includes(this.form.write_off_status)
      },
      allowReview () {
        return [5, 6].includes(this.form.status) && this.$route.meta.isReview
      },
      showScheduleDate () {
        return [2, 3].includes(this.form.type) && !!this.form.schedule_date
      },
      shouldShowPaymentAccount () {
        // 是否回显付款账户：状态为8，10，16时需回显原付款账户且禁用编辑
        return [8, 10, 16].includes(this.form.status)
      }
    },
    watch: {},
    beforeRouteEnter (to, from, next) {
      next(vm => vm.onLoad())
    },
    beforeRouteUpdate (to, from, next) {
      this.onReload()
      next()
    },
    created () {},
    mounted () {},
    methods: {
      ...request.map([
        'getProjectTable',
        'getProjectDetail',
        'getPlatformUsersIndex',
        'getPlatformUsersDetail',
        'getCompanyAccountManagementTable',
        'getCompanyAccountManagementDetail',
      ]),
      async onLoad () {
        await this.getFinCenterConfigs()
        if (this.$route.params.id) {
          this.setForm(this.id = this.$route.params.id)
        } else {
          this.fetchUserDetail('getuserAccountDetailByUserID', {id: this.user.id})
        }
      },
      onReload () {
        Object.assign(this.$data, this.$options.data.call(this))
        this.onLoad()
      },
      setForm (id) {
        let api = 'getPaymentManagerDetail'
        if (this.$route.meta.isApproval) {
          api = 'getPaymentDetailFinanceApi'
        }
        request(api, {id}).then(async ({data}) => {
          await this.setupProjectNames(data)
          filter.setLoop(this.form, data)
          // 状态为16时，付款账户需要回显（使用原有付款账户的 id），其他场景不回显
          if (this.shouldShowPaymentAccount && data.payment_company_account && data.payment_company_account.id) {
            this.payment_company_account_id = data.payment_company_account.id
          }
          // 付款状态为 已付款/已部分付款时，需要回填 付款日期
          if ([8, 10].includes(this.form.status) && data.paid_date !== '') {
            this.paid_date = data.paid_date
          }
          this.form.purpose = data.purpose || ''
          // this.form.paid_attached_file = data.paid_attached_file || []
          this.setupLog(data)
          this.setupSubjects(data)
          this.fetchPlatformUsersWithCCids(data)
          this.setupAttachedFile()

          this.setupOtherData(data)

          this.setupRefundData(data)
          this.showErrorMsg = false
        }).catch((e) => {
          this.detailErrorMsg = String(e).replace(/^Error:\s*/i, '')
          this.showErrorMsg = true
        })
      },
      setupRefundData (data) {
        this.form.refund_detail = data.refund_detail.reverse()
        this.refundForm.refund_detail = data.payment_detail.map(item => {
          return {
            id: item.id,
            refund_amount: item.paid_amount,
          }
        })
      },
      setupLog (data) {
        this.form.log = data.log.reduce((total, item) => {
          return total + `${item.created_at} ${item.admin_name}/${item.admin_real_name || '-'} ${item.desc}\n`
        }, '')

        // this.form.refund_log = data.refund_detail.reduce((total, item) => {
        //   return total + `${item.created_at} ${item.creator_name} 退款 ￥${item.refund_amount_total} 退款条目ID：${item.id}\n`
        // }, '')
      },
      setupSubjects (data) {
        const firstSubjectIds = this.associatedRelationships[this.form.type]
        const firstSubjects = {}
        for (const id in firstSubjectIds) {
          firstSubjects[id] = this.originFirstSubjects[id]
        }
        this.firstSubjects = firstSubjects

        data.payment_detail.forEach((item, index) => {
          // 有实付金额，取实付金额，否则取确认金额，不再取应付金额
          item.paid_amount = Number(item.paid_amount) || item.confirm_amount
          const secondSubjects = {}
          const secondSubjectIds = firstSubjectIds[item.first_subject]
          for (const index in secondSubjectIds) {
            const id = secondSubjectIds[index]
            secondSubjects[id] = this.originSecondSubjects[id]
          }
          this.secondSubjects[index] = secondSubjects

          // 当一级科目被禁用的时候，需要重置为 null
          if (!this.firstSubjects[item.first_subject]) {
            item.first_subject = null
          }

          // 当二级科目被禁用的时候，需要重置为 null
          if (!secondSubjects[item.second_subject]) {
            item.second_subject = null
          }
        })
      },
      setupProjectNames (data) {
        let reqProjectApis = []
        this.projectNames = {
          '0': '无'
        }
        data.payment_detail.forEach((item, index) => {
          item.project_id = item.project_id + ''
          reqProjectApis.push(item.project_id)
        })
        data.write_off_lists.forEach(writeOff => {
          writeOff.write_off_detail.forEach((item, index) => {
            item.project_id = item.project_id + ''
            reqProjectApis.push(item.project_id)
          })
        })
        reqProjectApis = _.uniq(reqProjectApis)
        reqProjectApis = reqProjectApis.filter(item => item > 0).map(id => request('getProjectDetail', {id: id}))
        return request.all.common(reqProjectApis).then(res => {
          res.map(item => {
            if (item.data.name && item.data.number) {
              this.projectNames[item.data.id] = item.data.name
              // return item.data.name + '/' + item.data.number
            }
            // return '无'
          })
        })
      },
      setupAttachedFile () {
        // 申请的 附件
        this.form.attached_file.forEach((file, index) => {
          if (file.type === 'pic') {
            request.common('getFinCenterFileUrl', file).then((res) => {
              this.$set(this.form.attached_file[index], 'pic_url', res.data)
            })
          }
        })
        // 付款附件
        this.form.paid_attached_file.forEach((file, index) => {
          if (file.type === 'pic') {
            request.common('getFinCenterFileUrl', file).then((res) => {
              this.$set(this.form.paid_attached_file[index], 'pic_url', res.data)
            })
          }
        })
        // 冲销附件
        this.form.write_off_lists.forEach((item, index) => {
          item.attached_file.forEach((file, subIndex) => {
            if (file.type === 'pic') {
              request.common('getFinCenterFileUrl', file).then((res) => {
                this.$set(this.form.write_off_lists[index].attached_file[subIndex], 'pic_url', res.data)
              })
            }
          })
        })
      },
      fetchPlatformUsersWithCCids (data) {
        if (data.cc.length > 0) {
          const adminuserIds = [...data.cc]
          const ccNames = []
          request.common('fetchApproverRealName', {user_id: adminuserIds}).then((res) => {
            res.data.forEach(item => {
              ccNames.push(`${item.user_name}/${item.name || '-'}`)
            })
            this.form.cc_name = ccNames.join('\t')
          })
        } else {
          this.form.cc_name = '无'
        }
      },
      setupOtherData (data) {
        if (data.paid_to_type === 1) {
          this.fetchUserDetail('getUserBankAccountById', {id: data.user_bank_account_id})
        }
        if ([8, 10].includes(data.status)) {
          // this.form.write_off = data.write_off_lists.reduce((total, item) => {
          //   return total + Number(item.amount)
          // }, 0)
          this.form.wait_write_off = this.form.paid_amount_total - this.form.written_off_amount
        }
        if (this.form.paid_to_type === 2) {
          this.getCompanyAccountsDetail(data)
          // this.getCompanyAccountsDetail({id: this.form.company_bank_account_id})
        }
      },
      getForm () {
        return filter.copyJson(this.form)
      },
      checkRefundPaymentDetail () {
        if (!this.refundForm.refund_date) {
          this.$message.error('请选择退款日期')
          return false
        }
        if (!this.refundForm.refund_desc) {
          this.$message.error('请填写退款备注')
          return false
        }
        this.refundForm.refund_detail.forEach(item => {
          if (!item.refund_amount) {
            this.$message.error('请填写退款金额')
            return false
          }
        })
        return true
      },
      onRefund () {
        if (!this.checkRefundPaymentDetail()) {
          return
        }
        request.common('refundPayment', {id: this.id, ...this.refundForm}).then((res) => {
          this.$confirm('退款成功, 是否继续添加？', '提示', {type: 'success'}).then(() => {
            this.setForm(this.id)
            this.retsetRefundForm()
            this.$refs.refundUpload.clearFiles()
          }, () => {
            this.$router.push({path: this.tablePath})
          })
        })
      },
      retsetRefundForm () {
        this.refundForm.attached_file = []
        this.refundForm.refund_desc = null
        this.refundForm.refund_date = null
      },
      onViewImage (event) {
        if (event.target.src) {
          this.views = new Viewer(event.target, {
            url: (image) => event.target.src,
          })
        }
        this.views.view()
      },
      onGetPdfFile (item) {
        this.$confirm('确认下载文件?', '提示', {
          distinguishCancelAndClose: true,
          confirmButtonText: '下载',
          cancelButtonText: '查看',
          type: 'warning',
        }).then(() => {
          downloadJS(request.items.getFinCenterFileUrlForDownload(item), false, false, {
            'SJ-Auth-Token': getToken()
          })
        }).catch(action => {
          if (action === 'cancel') {
            this.tryOpenAttachFile(item)
          }
        })
      },
      tryOpenAttachFile (item) {
        if (item.type === 'pdf') {
          request.common('getFinCenterFileUrl', item).then(({data}) => {
            window.open(data)
          })
        } else if (item.type === 'eml') {
          this.attach_file_url = request.items.getFinCenterFileUrlForDownload(item)
          this.file_title = item.title
          this.attach_file_visible = true
        } else {
          this.$message({
            type: 'error',
            message: '暂不支持预览操作',
          })
        }
      },
      fetchUserDetail (uri, params) {
        request.common(uri, params).then(({data}) => {
          if (this.$route.params.id) {
            if (this.form.paid_to_type === 1) {
              this.form.user_bank_account_id = data.id
              this.form.company_name = data.name
              this.form.bank_account = data.bank_account
              this.form.bank = data.bank
              this.form.bank_headquarters = data.bank_headquarters
            }
          } else {
            this.form.department_id = data.id
            this.userDetail = data
            this.form.first_approver = data.first_approver
            this.form.second_approver = data.second_approver
            this.form.third_approver = data.third_approver
            this.form.fourth_approver = data.fourth_approver
          }
        })
      },
      getFinCenterConfigs () {
        return request.common('getFinCenterConfigs').then(({data}) => {
          this.setupSubjectsFromFinCenterConfigs(data)
          this.setupPaymentCompany(data)
        })
      },
      setupSubjectsFromFinCenterConfigs (data) {
        this.originFirstSubjects = this.expandData(_.values(data.first_subject_source))
        this.originSecondSubjects = this.expandData(_.values(data.second_subject_source))
        this.associatedRelationships = data.payment_apply_subject_map
        this.writeOffAssociatedRelationships = data.payment_write_off_subject_map
      },
      setupPaymentCompany (data) {
        this.paymentCompanys = data.payment_apply_our_company_source.reduce((o, k) => {
          o[k.id] = k.name
          return o
        }, {})
      },
      expandData (data) {
        // data = data.filter(item => { return item.is_disabled < 1 })
        let result = {}
        for (const dataKey in data) {
          const tmp = data[dataKey]
          result[tmp.id] = tmp.name
        }
        return result
      },
      getCompanyAccounts (key) {
        return request.common('getCompanyBankAccountTable', {company_name: key.keyword})
      },
      getCompanyAccountsDetail (data) {
        // request.common('getCompanyBankAccountById', id).then(data => {
        this.form.company_name = data.bank_account_snapshot.company_name
        this.form.bank_account = data.bank_account_snapshot.bank_account
        this.form.bank = data.bank_account_snapshot.bank
        this.form.bank_headquarters = data.bank_account_snapshot.bank_headquarters
        // })
      },
      downloadPDF () {
        this.onDownloadDetail = true
        downloadJS(request.items.exportPaymentApplicationPDF({id: this.id}), false, false, {
          'SJ-Auth-Token': getToken()
        }, () => {
          this.onDownloadDetail = false
        })
      },
      firstSubjectChange (val, index) {
        this.form.payment_detail[index].second_subject = null
        const secondSubjects = {}
        const secondSubjectIds = this.associatedRelationships[this.form.type][val]
        for (const index in secondSubjectIds) {
          const id = secondSubjectIds[index]
          secondSubjects[id] = this.originSecondSubjects[id]
        }
        this.secondSubjects[index] = secondSubjects
      },
      invoiceTypeChange (val, index) {
        if (val === 1) {
          this.form.payment_detail[index].tax_rate = 0
        } else {
          this.form.payment_detail[index].tax_rate = null
        }
      },
      handleExceed (files, fileList, max) {
        this.$message.warning(`当前限制选择 ${max} 个文件，本次选择了 ${files.length} 个文件，共选择了 ${files.length + fileList.length} 个文件`)
      },
      beforeRemove (file, fileList, formField) {
        let fileTemp
        if (file.raw) {
          fileTemp = file.raw
        } else {
          fileTemp = file
        }
        let index = this.getFileListIndex(fileTemp, fileList)
        if (index > -1) {
          formField.splice(index, 1)
        }
      },
      getFileListIndex (file, fileList) {
        for (let i = 0; i < fileList.length; i++) {
          let fileTemp
          if (fileList[i].raw) {
            fileTemp = fileList[i].raw
          } else {
            fileTemp = fileList[i]
          }
          if (file === fileTemp) {
            return i
          }
        }
        return -1
      },
      onChangeFile (file, fileList, formField, uri = 'finCenterUploadPaymentApplyFile') {
        let isLt5M = file.raw.size / 1024 / 1024 < 50
        if (!isLt5M) {
          this.$message.error('文件内容必须小于5MB!')
          this.$refs.upload.uploadFiles.pop()
          return false
        }
        this.onUploadFile(file.raw, fileList, formField, uri)
      },
      onUploadFile (file, fileList, formField, uri) {
        let formData = new FormData()
        formData.append('file', file)
        this.id && formData.append('apply_id', this.id)
        return request.alert(uri, formData).then(({data}) => {
          this.$message({
            showClose: true,
            message: '上传成功',
            type: 'success',
          })
          let index = this.getFileListIndex(file, fileList)

          let type = file.name.split('.').pop().toLowerCase()
          if (['jpeg', 'jpg', 'png'].includes(type)) {
            type = 'pic'
          } else if (['pdf'].includes(type)) {
            type = 'pdf'
          } else if (['eml', 'html', 'htm'].includes(type)) {
            type = 'eml'
          } else if (['xlsx', 'doc', 'docx'].includes(type)) {
            type = 'office'
          } else if (['zip'].includes(type)) {
            type = 'zip'
          }
          if (index > -1) {
            formField[index] = {name: file.name, url: data, type: type}
          }
        }).catch(_ => {
          this.$refs.upload.uploadFiles.pop()
        })
      },
      review (uri, params) {
        request.common(uri, params).then((res) => {
          this.$confirm('审核成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
            this.$router.push({path: this.tablePath})
          }, () => {
            this.setForm(this.id)
          })
        })
      },
      reviewURIandParams () {
        let uri = ''
        const params = {id: this.id}
        if ([1, 2, 3, 4, 13, 14].includes(this.form.status)) {
          uri = 'reviewPaymentApplication'
        } else {
          if (this.form.status === 5) {
            uri = 'accountantReviewPaymentApplication'
          } else if (this.form.status === 6) {
            uri = 'managerReviewPaymentApplication'
          }
          params.payment_detail = this.getPaymentDetailforSubmit()
        }
        return {uri, params}
      },
      onReview (status) {
        const {uri, params} = this.reviewURIandParams()
        if (status) {
          this.$confirm('确认审核通过吗？', '审核通过', {type: 'warning'}).then(() => {
            params.is_rejected = 0
            this.review(uri, params)
          })
        } else {
          if (this.reason && this.reason.length > 0) {
            params.is_rejected = 1
            params.reason = this.reason
            this.review(uri, params)
          } else {
            this.$message.error('请输入驳回原因')
          }
        }
      },
      onPayment () {
        const status = Number(this.form.status)
        const files = this.form.paid_attached_file || []
        // 新接口要求仅允许一个附件
        if ([8, 10, 16].includes(status)) {
          if (files.length === 0) {
            this.$message.error('请上传回执附件')
            return false
          }
          if (files.length > 1) {
            this.$message.error('回执附件仅支持上传1个文件')
            return false
          }
          if (status === 16 && !this.paid_date) {
            this.$message.error('支付中状态必须填写付款日期')
            return false
          }
          const params = {
            id: this.id,
            paid_date: this.paid_date,
            paid_attached_file: files,
          }
          this.$confirm('确认上传回执吗？', '付款完成', {type: 'warning'}).then(() => {
            request.common('uploadPaymentReceipt', params).then(() => {
              this.$confirm('操作成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
                this.$router.push({path: this.tablePath})
              }, () => {
                this.setForm(this.id)
              })
            })
          })
          return
        }
        // 其它状态沿用付款申请接口
        if (!this.payment_company_account_id) {
          this.$message.error('请选择付款账户')
          return false
        }
        if (!this.paid_date) {
          this.$message.error('付款日期不能为空')
          return false
        }
        const params = {
          id: this.id,
          paid_date: this.paid_date,
          payment_company_account_id: this.payment_company_account_id,
          paid_attached_file: files,
          payment_detail: this.getPaymentDetailforSubmit()
        }
        this.$confirm('确认付款吗？', '付款', {type: 'warning'}).then(() => {
          request.common('paymentApplication', params).then(() => {
            this.$confirm('付款成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: this.tablePath})
            }, () => {
              this.setForm(this.id)
            })
          })
        })
      },
      getPaymentDetailforSubmit () {
        return this.form.payment_detail.map(item => {
          return {
            id: item.id,
            first_subject: item.first_subject,
            second_subject: item.second_subject,
            amount: item.amount,
            paid_amount: item.paid_amount,
            invoice_type: item.invoice_type,
            tax_rate: item.tax_rate,
            finance_desc: item.finance_desc
          }
        })
      },
      onEditPaidAmount () {
        const params = {
          id: this.id,
          payment_detail: this.form.payment_detail,
        }
        this.$confirm('确认修改实付金额吗？', '修改', {type: 'warning'}).then(() => {
          request.common('editPaidAmountAfterPaid', params).then((res) => {
            this.$confirm('修改实付金额成功, 是否返回列表？', '提示', {type: 'success'}).then(() => {
              this.$router.push({path: this.tablePath})
            }, () => {
              this.setForm(this.id)
            })
          })
        })
      },
      writeOffTotalAmount (index) {
        const writeOff = this.form.write_off_lists[index]
        return writeOff.write_off_detail.reduce((total, item) => {
          return total + Number(item.amount)
        }, 0)
      },
      writeOffTotalInvoiceCount (index) {
        const writeOff = this.form.write_off_lists[index]
        return writeOff.write_off_detail.reduce((total, item) => {
          return total + Number(item.invoice_count)
        }, 0)
      },
      onCancel () {
        this.$router.push({path: this.tablePath})
      },
      closeDialog () {
        this.attach_file_visible = false
      },
      searchDepartments (name) {
        return request.common('getFinCenterDepartmentTableList', {...name, is_disabled: 0})
      },
      getDepartmentDetail (id) {
        return request.common('getFinCenterDepartmentDetail', id)
      },
    },
  }
  </script>
  <style lang="scss">
  // 全局CSS
  </style>
  <style lang="scss"
         scoped>
  .col-center {
    text-align:center
  }
  .invoice-row .el-col {
    line-height: 30px;
    text-align: center;
  }

  .payment-detail-table {
    width: 100%;
  }

  .attachments-summary-row {
    display: flex;
    align-items: flex-start;
    justify-content: space-between;
    gap: 20px;
    padding-top: 20px;
  }

  .attachments-summary-row__attachments {
    flex: 1 1 auto;
    min-width: 0;
    margin-bottom: 0;
  }

  .attachments-summary-row__summary {
    flex: 0 0 auto;
  }

  .invoice-summary {
    display: flex;
    justify-content: flex-end;
    width: 100%;
  }

  .invoice-summary__list {
    min-width: 260px;
  }

  .invoice-summary__item {
    display: flex;
    align-items: center;
    line-height: 22px;
    color: #F56C6C;
    margin: 6px 0;
  }

  .invoice-summary__label {
    white-space: nowrap;
    width: 140px;
    text-align: right;
    padding-right: 10px;
  }

  .invoice-summary__value {
    min-width: 120px;
    text-align: left;
    white-space: nowrap;
  }

  .view-navbar {
    right: 0px;
    bottom: 0px;
    width: 100%;
    overflow: hidden;
    display: inline;
    float: left;

    ul {
      transform: translateX(0px);
      transition: all 0.3s;
      box-sizing: content-box;
      // height: 100px;
      overflow: hidden;
      padding: 1px 0;

      li {
        float: left;
        list-style: none;
        width: 100px;
        height: 100px;
        margin-right: 5px;
        cursor: pointer;
        font-size: 0;
        line-height: 0;
        overflow: hidden;
        transition: opacity 0.15s;
      }
    }
  }
  // 带作用域的CSS
  // https://vue-loader.vuejs.org/zh-cn/features/scoped-css.html
  </style>
  <style lang="scss"
         module>
  // 带作用域的CSS
  // 绑定class方式 <p :class="$style.red"></p>
  // https://vue-loader.vuejs.org/zh-cn/features/css-modules.html
  </style>



// WEBPACK FOOTER //
// src/views/payment-center/pages/PaymentCenterReview.vue